var map = {
	"app/_new-diagrama/new-fabric.module": [
		"./src/app/_new-diagrama/new-fabric.module.ts",
		"default~app-_new-diagrama-new-fabric-module~app-_nt-f4bric-diagrama-module",
		"app-_new-diagrama-new-fabric-module"
	],
	"app/_new-tecnoscopio-v2/checkout-guest/checkout-guest.module": [
		"./src/app/_new-tecnoscopio-v2/checkout-guest/checkout-guest.module.ts",
		"default~app-_new-tecnoscopio-v2-checkout-guest-checkout-guest-module~app-_new-tecnoscopio-v2-profile~516132bc",
		"app-_new-tecnoscopio-v2-checkout-guest-checkout-guest-module"
	],
	"app/_new-tecnoscopio-v2/courses/course.module": [
		"./src/app/_new-tecnoscopio-v2/courses/course.module.ts",
		"app-_new-tecnoscopio-v2-courses-course-module"
	],
	"app/_new-tecnoscopio-v2/impersonate-user/impersonate-user.module": [
		"./src/app/_new-tecnoscopio-v2/impersonate-user/impersonate-user.module.ts",
		"app-_new-tecnoscopio-v2-impersonate-user-impersonate-user-module"
	],
	"app/_new-tecnoscopio-v2/new-cursos/new-cursos.module": [
		"./src/app/_new-tecnoscopio-v2/new-cursos/new-cursos.module.ts",
		"app-_new-tecnoscopio-v2-new-cursos-new-cursos-module"
	],
	"app/_new-tecnoscopio-v2/new-index/new-index.module": [
		"./src/app/_new-tecnoscopio-v2/new-index/new-index.module.ts",
		"common",
		"app-_new-tecnoscopio-v2-new-index-new-index-module"
	],
	"app/_new-tecnoscopio-v2/new-lista-diagramas/new-lista-diagramas.module": [
		"./src/app/_new-tecnoscopio-v2/new-lista-diagramas/new-lista-diagramas.module.ts",
		"app-_new-tecnoscopio-v2-new-lista-diagramas-new-lista-diagramas-module"
	],
	"app/_new-tecnoscopio-v2/new-trocar-documento/new-trocar-documento.module": [
		"./src/app/_new-tecnoscopio-v2/new-trocar-documento/new-trocar-documento.module.ts",
		"app-_new-tecnoscopio-v2-new-trocar-documento-new-trocar-documento-module"
	],
	"app/_new-tecnoscopio-v2/new-validar-certificado/new-validar-certificado.module": [
		"./src/app/_new-tecnoscopio-v2/new-validar-certificado/new-validar-certificado.module.ts",
		"app-_new-tecnoscopio-v2-new-validar-certificado-new-validar-certificado-module"
	],
	"app/_new-tecnoscopio-v2/news/new.module": [
		"./src/app/_new-tecnoscopio-v2/news/new.module.ts",
		"common",
		"app-_new-tecnoscopio-v2-news-new-module"
	],
	"app/_new-tecnoscopio-v2/plans/plan.module": [
		"./src/app/_new-tecnoscopio-v2/plans/plan.module.ts",
		"common",
		"app-_new-tecnoscopio-v2-plans-plan-module"
	],
	"app/_new-tecnoscopio-v2/profile/profile.module": [
		"./src/app/_new-tecnoscopio-v2/profile/profile.module.ts",
		"default~app-_new-tecnoscopio-v2-checkout-guest-checkout-guest-module~app-_new-tecnoscopio-v2-profile~516132bc",
		"common",
		"app-_new-tecnoscopio-v2-profile-profile-module"
	],
	"app/_new-tecnoscopio-v2/quality/quality.module": [
		"./src/app/_new-tecnoscopio-v2/quality/quality.module.ts",
		"app-_new-tecnoscopio-v2-quality-quality-module"
	],
	"app/_new-tecnoscopio-v2/site-de-testes/site-de-testes.module": [
		"./src/app/_new-tecnoscopio-v2/site-de-testes/site-de-testes.module.ts"
	],
	"app/_nt-f4bric/diagrama.module": [
		"./src/app/_nt-f4bric/diagrama.module.ts",
		"default~app-_new-diagrama-new-fabric-module~app-_nt-f4bric-diagrama-module",
		"app-_nt-f4bric-diagrama-module"
	],
	"app/shared/formulario/recover/recover.module": [
		"./src/app/shared/formulario/recover/recover.module.ts",
		"app-shared-formulario-recover-recover-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;